var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as PropTypes from 'prop-types';
import * as React from 'react';
import { AppStyledIcon } from './style';
var AppIcon = /** @class */ (function (_super) {
    __extends(AppIcon, _super);
    function AppIcon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AppIcon.prototype.render = function () {
        return React.createElement(AppStyledIcon, __assign({}, this.props));
    };
    AppIcon.propTypes = {
        className: PropTypes.string,
        name: PropTypes.string,
        onClick: PropTypes.func,
        style: PropTypes.object,
        title: PropTypes.string,
    };
    return AppIcon;
}(React.Component));
export default AppIcon;
//# sourceMappingURL=index.js.map